import { customElement, property, query } from 'lit/decorators';
import { css, html, LitElement, unsafeCSS } from 'lit';
import hljs from 'highlight.js';
import highlightcss from 'bundle-text:highlight.js/styles/github.css';

@customElement('pdq-code-html')
export class PDQCodeHtml extends LitElement {
  static styles = [
    unsafeCSS(highlightcss),
    css`
    pre {
      margin: 0;
      background: var(--cds-layer-accent-01, #f0f0f0);
      padding: 16px;
      border-radius: 8px;
      overflow: auto;
      min-height: 16px;
    }
    .main{
        position: relative;
    }
    cds-copy-button {
        position: absolute;
        right: 8px;
        top: 8px;
    };
  `];

  @query('pre') pre: HTMLElement | undefined;

  @property({ type: String })
  code: string = '';

  @property({ type: String })
  language: string = 'HTML';

  protected firstUpdated() {
    if (this.pre)
      this.pre.innerHTML = `<code>${hljs.highlight(this.code, { language: this.language }).value}</code>`;
  }

  protected render() {
    return html`
      <div class="main">
        <cds-copy-button feedback="Copied!" feedback-timeout="2000"
                         @click="${() => navigator.clipboard.writeText(this.code?.trim())}">
          Copy Code
        </cds-copy-button>
        <pre class="language-html"><code></code></pre>
      </div>
    `;
  }

  protected updated(_changedProperties: Map<string | number | symbol, unknown>): void {
    if (_changedProperties.has('code')) {
      if (this.pre)
        this.pre.innerHTML = `<code>${hljs.highlight(this.code, { language: this.language }).value}</code>`;
    }
  }
}